import type { TOC } from '@ember/component/template-only';
import { PrismCard, PrismIcon } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

interface HotelMinLosCardSignature {
  Args: {
    currentLabel: string;
    formattedRecommendation: string;
    hasException: boolean;
    isLoading: boolean;
  };
}

/* Read-only: the hotel MinLOS summarises the rate groups and has no automation
   or override of its own. A failed rate group MinLOS push shows as a generic
   failure; a rate group push in progress shows as loading, since the BE
   recalculates the hotel value from the rate groups. */
const HotelMinLosCard = <template>
  <PrismCard
    @contentLayout="noPadding"
    class="mx-500 my-400"
    data-test-id="hotel-min-los-card"
  >
    <:header as |Header|>
      <Header.title>{{t "general.hotel"}}</Header.title>
    </:header>
    <:headerAfter>
      {{#if @isLoading}}
        <div
          class="loading-pulse w-[120px]"
          data-test-id="hotel-min-los-loading"
        ></div>
      {{else}}
        <div class="flex flex-col items-end">
          {{#if @hasException}}
            <div
              class="text-critical-default flex items-center gap-100"
              data-test-id="hotel-min-los-exception"
            >
              <PrismIcon
                @color="critical"
                @name="circle-minus"
                @size="small"
                aria-hidden="true"
              />
              <p class="text-300--medium">
                {{t "pricing_manager.restrictions.trouble_updating"}}
              </p>
            </div>
          {{else}}
            <p
              class="text-300--regular"
              data-test-id="hotel-min-los-recommendation"
            >
              {{@formattedRecommendation}}
            </p>
          {{/if}}
          <p
            class="text-200--regular text-neutral-subdued"
            data-test-id="hotel-min-los-current-value"
          >
            {{@currentLabel}}
          </p>
        </div>
      {{/if}}
    </:headerAfter>
  </PrismCard>
</template> satisfies TOC<HotelMinLosCardSignature>;

export default HotelMinLosCard;
